
export const Home = {
  onLoad: function() {
    if ($('.template-home').length) {
      this.initHero();
    }
  },
  initHero: function() {
    if ($('#hero').length) {
      if ($('#typed-strings').length) {
        this.initTyped();
      }
      if ($('#title-animation').length) {
        Title_Animation.onLoad();
      }
    }
  },
  initTyped: function() {
    /* eslint-disable no-undef */
    Typed.new('#typed', {
      stringsElement: document.getElementById('typed-strings'),
      showCursor: true,
      autoInsertCss: true,
      typeSpeed: 70,
      backDelay: 2000,
      backSpeed: 70,
      loop: true,
      contentType: 'html', // or text
      // defaults to null for infinite loop
      loopCount: null,
      callback: function(){
        console.log('callback');
      },
      // resetCallback: function() {
      //   console.log('resetCallback');
      // }
    });
  },
};

const Title_Animation = {
  onLoad: function() {
    const strings = this.getStrings();
    this.onAnimate(strings);
  },
  getStrings: function() {
    let strings = [];
    $('#title-animation-strings span').each(function() {
      strings.push($(this).text());
    });
    return strings;
  },
  onAnimate: function(strings) {
    let inc = 0;
    $('#title-animation').text(strings[0]);
    this.fadeIn();
    inc++;
    this.onFadeOut();
    setInterval(function() {
      $('#title-animation').text(strings[inc]);
      Title_Animation.fadeIn();
      if (inc >= (strings.length - 1)) {
        inc = 0;
      } else {
        inc++;
      }
      Title_Animation.onFadeOut();
    }, 1500);
  },
  fadeIn: function() {
    $('#title-animation').addClass('fadeIn').removeClass('fadeOut');
  },
  onFadeOut: function() {
    setTimeout(function() {
      $('#title-animation').removeClass('fadeIn').addClass('fadeOut');
    }, 1000);
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/Home.js